export const PATTERN_USERNAME = '^[a-zA-Z0-9-_.]+$';



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/constants/form-validation.constants.ts